import React, { useEffect, useRef, useState } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { buildName, Singleton } from "helper/tools";
import "./cobranza.css";
import styles from "./cobranzaOther.module.css";
//import toolTipStyles from "./../tooltip.module.css";

import { format } from "date-fns";
//import { ordenesVentas } from "helper/helper";

import { HiDotsVertical } from "react-icons/hi";
import { PiHandshakeFill, PiHandshake } from "react-icons/pi";

export default function CobranzaReestructuraTable({
  items,
  lastParcialInfo,
  cobranzaInfoDetail,
  openItem,
  openConvenio,
  handleDetail,
  handleSortChange,
  openEstadoCuenta,
  abonarCliente,
  abonarProducto,
  isLoading = false,
}) {
  const theadRef = useRef();

  const tDetalleRef = useRef([]);
  const tDetalleIsShownRef = useRef([]);
  //  const asociadosClientesRef = useRef({});
  //const [asociadosClientes, setAsociadosClientes] = useState({});

  const [areLoading, setAreLoading] = useState(false);

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    /*  const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }
  
    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });*/
  }

  /*async function toggleDetails(index, asociadoId) {
    console.log(items);
    if (tDetalleIsShownRef.current[index] == null) return;
    /*tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";
    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index]; /

    if (asociadosClientes[asociadoId] != null) {
      showClienteRow(index);
      return;
    }

    /*if (
      tDetalleIsShownRef.current[index] &&
      asociadosClientesRef.current[asociadoId] == null
    ) { /
    if (asociadosClientes[asociadoId] == null) {
      const response = await api.asociadoClientes(asociadoId).catch((error) => {
        toast.error("Error al pedir Niveles.");
        //setIsLoading(false);
      });
      asociadosClientes[asociadoId] = response.data.clientes;
      setAsociadosClientes({ ...asociadosClientes });

      showClienteRow(index);
    }
  }*/
  async function toggleDetails(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  }

  async function openModals(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  }

  function showClienteRow(index) {
    //if (items[index].clientes.length === 0) {
    if (items[index].ordenParcialidades.length === 0) {
      //} == null) {
      tDetalleIsShownRef.current[index] = true;

      const newloading = !areLoading;
      setAreLoading(newloading);

      setTimeout(function () {
        handleDetail(index, () => {
          tDetalleRef.current[index].style.display = "flex";
          tDetalleIsShownRef.current[index] = true;
          setAreLoading(!newloading);

          generatePDF(null, items[index]);

          //  setAsociadosClientes({ index: index });
        });
      }, 200);

      /*  */
      return;
    }
    if (tDetalleIsShownRef.current[index] == null) return;

    //  setTimeout(function () {
    tDetalleIsShownRef.current.forEach((element, index) => {
      tDetalleIsShownRef.current[index] = false;
    });

    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index];

    console.log(`--toreto ${index} ${tDetalleRef.current[index]} ++`);

    /*tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";*/
    //}, 3000);

    setTimeout(function () {
      setAreLoading(!areLoading);
    }, 200);

    //generatePDF(null, items[index]);
  }

  function generatePDF(event, item) {
    //onGenerateTicket("b64", item);
    const item2 = {
      cliente: { nombre: "aq1", direcciones: [] },
      ordenVentaDetalles: [
        {
          asociado: { nombre: "rewerw" },
          cliente: { nombre: "aq1", direcciones: [] },
          producto: {
            nombre: "roundo",
          },
          precio: 234,
          cantidad: 2,
          total: 450,
        },
      ],
    };

    /*
  }]

    }

    item.ordenVentaDetalles
    .map(function (info) {
      const nombre = [
        {
          text: info.producto.nombre,
          style: "tProductsBody",
          colSpan: 4,
          lineHeight: 0,
        },
        {},
        {},
        {},
      ];

      const descripcion = [
        { text: info.cantidad, style: "tProductsBody", alignment: "center" },
        {
          text: "",
          style: "tProductsBody",
          alignment: "center",
        },
        {
          text: Singleton.getInstance().format(info.precio),
          style: "tProductsBody",
          alignment: "right",
        },
        {
          text: Singleton.getInstance().format(info.total),
          style: "tProductsBody",
          alignment: "right",
        },
      ];

      const re = [nombre, descripcion];

      return re;
    })
    .flatMap((info) => info);*/
    /*
  const total = Singleton.getInstance().format(item.totalVenta);
  const subTotal = Singleton.getInstance().format(item.subTotalVenta);
  const descuento = Singleton.getInstance().format("0.0");
  //const subTotalLetra = NumeroALetras(item.subtotal)
  const totalLetra = NumeroALetras(item.totalVenta, true);
  //"SON: SEISCIENTOS TREINTA MIL QUINIENTOS CINCO Y CINCO CON 00/100 PESOS",

  const asociadoNombre = buildName(item.asociado, true);
  const clienteNombre = buildName(item.cliente, true);
  let domicilioCliente = "---";
  if (item.cliente.direcciones.length > 0) {
    const address = item.cliente.direcciones[0];
    const infos = [
      address.calle,
      address.noExterior,
      address.colonia,
      address.cp,
      address.ciudad,
      address.estado,
    ];
    domicilioCliente = infos.join(", ");
  }*/

    //
    //onGenerateEstadoCuentaPDF("print", item);
  }

  useEffect(() => {
    tDetalleIsShownRef.current.length = 0;
    tDetalleIsShownRef.current = new Array(items.length).fill(false);

    tDetalleRef.current = new Array(items.length).fill("");
  }, [items]);

  let currentParcialidadDate =
    lastParcialInfo?.fechaInicio != null
      ? format(lastParcialInfo?.fechaInicio, "dd-MMM-yy")
      : "";

  return (
    <>
      <div className="row">
        {/*<h2>Outer Table with Inner Table</h2>*/}

        <table
          className="table table-borderless datable sortable table-hover table-fork"
          style={{ backgroundColor: "lightblue" }}
          width="100%"
        >
          <thead className="table-light" style={{ textAlign: "center" }}>
            <tr className={styles.has_tr}>
              <th
                scope="col"
                data-column="asociado.id"
                style={{
                  width: "90px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Id
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Producto
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  width: "105px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                <div>Fecha de Venta</div>
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  width: "105px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Precio
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  width: "105px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Plazo
              </th>

              <th
                scope="col"
                data-column="asociado.nombre"
                style={{
                  textAlign: "center",
                  width: "105px",
                  verticalAlign: "middle",
                }}
                onClick={(event) => handleSort(event)}
              >
                Abono
              </th>

              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "105px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Pagado
              </th>
              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "105px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Debe
              </th>
              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "105px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {currentParcialidadDate}
              </th>
              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "105px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Adeudo Quincenal
              </th>
              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "105px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Nuevo Saldo
              </th>

              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "105px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Comisión
              </th>

              <th
                scope="col"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "150px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Abono Adicional
              </th>
              <th
                scope="col"
                className="no-sort"
                data-column="asociado.credito"
                onClick={(event) => handleSort(event)}
                style={{
                  width: "100px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              ></th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <SkeletonTable columnCount={14} rowCount={6} />}
            {!isLoading &&
              items.map((cobranzaItem, index) => {
                //const numCliente = cobranzaItem?.ordenVentaDetalle?.producto?.nombre ?? "-";

                let nombre = "ASOCIADO";
                if (cobranzaItem?.cliente != null) {
                  nombre = buildName(cobranzaItem?.cliente ?? "ASOCIADO", true);
                }

                ///
                let clienteAbono = 0;
                let clientePagado = 0;
                let clienteDebe = 0;
                let clienteActual = 0;
                let clienteAdeudoQuincenal = 0;
                let clienteNuevoSaldo = 0;
                let clienteComision = 0;
                let clienteAbonoAdicional = "";
                ///
                const ordenParcialidades = cobranzaItem.ordenParcialidades;
                ordenParcialidades.forEach((ordenParcialidad) => {
                  ordenParcialidad.productoParcialidades.forEach(
                    (productoParcialidad) => {
                      let currentParcialidad =
                        productoParcialidad?.parcialidades.find(
                          (e) =>
                            e.parcialidadNumero ===
                            productoParcialidad?.parcialidadNumero,
                        );

                      clienteAbono += currentParcialidad.total;
                      //abono = Singleton.getInstance().format(abono);

                      clientePagado += productoParcialidad.totalPagado;
                      clienteDebe += productoParcialidad.totalPendiente;
                      clienteActual += currentParcialidad?.totalPagado ?? 0;
                      clienteAdeudoQuincenal +=
                        currentParcialidad?.totalPendiente ?? 0;

                      clienteNuevoSaldo = 0;
                      clienteComision = 0;
                      /*  clienteAbonoAdicional +=
                      productoParcialidad?.subPagoProductoAdicional?.total ?? 0;*/
                    },
                  );
                });
                //
                clienteDebe += cobranzaItem.interestItems.reduce(
                  (accumulator, interestItem) => {
                    return accumulator + interestItem.total;
                  },
                  0,
                );

                clientePagado += cobranzaItem.interestItems.reduce(
                  (accumulator, interestItem) => {
                    return accumulator + interestItem.totalPagado;
                  },
                  0,
                );

                clienteActual += cobranzaItem.interestItems.reduce(
                  (accumulator, interestItem) => {
                    return accumulator + interestItem.totalPagado;
                  },
                  0,
                );

                clienteAbono += cobranzaItem.interestItems.reduce(
                  (accumulator, interestItem) => {
                    return accumulator + interestItem.total;
                  },
                  0,
                );

                clienteAdeudoQuincenal += cobranzaItem.interestItems.reduce(
                  (accumulator, interestItem) => {
                    return accumulator + interestItem.totalPendiente;
                  },
                  0,
                );

                //
                clientePagado = Singleton.getInstance().format(clientePagado);
                clienteAbono = Singleton.getInstance().format(clienteAbono);
                clienteDebe = Singleton.getInstance().format(clienteDebe);
                clienteActual = Singleton.getInstance().format(clienteActual);
                clienteAdeudoQuincenal = Singleton.getInstance().format(
                  clienteAdeudoQuincenal,
                );
                clienteNuevoSaldo =
                  Singleton.getInstance().format(clienteNuevoSaldo);
                clienteComision =
                  Singleton.getInstance().format(clienteComision);
                /*clienteAbonoAdicional = Singleton.getInstance().format(
                clienteAbonoAdicional,
              );*/

                ///

                const totalPagar = Singleton.getInstance().format(
                  cobranzaItem.total,
                );

                const pendienteTotalParcialidad =
                  Singleton.getInstance().format(
                    cobranzaItem.pendienteTotalParcialidad,
                  );
                const comision = "-";
                const usoPagina = "-";
                const pagoGuia = "-";

                //const ordenParcialidades = cobranzaItem.ordenParcialidades;
                const productoParcialidades = ordenParcialidades.flatMap(
                  (e) => {
                    let end = e.productoParcialidades.map((u) => {
                      return { ...u, ordenesVenta: e.ordenVenta };
                    });
                    return end;
                  },
                );

                let pendienteActual = productoParcialidades.reduce(
                  (accumulator, productoParcialidad) => {
                    let currentParcialidad =
                      productoParcialidad?.parcialidades.find(
                        (e) =>
                          e.parcialidadNumero ===
                          productoParcialidad?.parcialidadNumero,
                      );

                    /*
         item.precioVenta;
    item.subTotal = item.cantidad * item.precio;
    */
                    return accumulator + currentParcialidad.totalPendiente;
                  },
                  0,
                );

                // TODO tiene mas que disponible
                //   let disableClienteAbonar = pendienteActual > cobranzaInfoDetail?.disponible;
                let disableClienteAbonar = false;

                //const parcialidadActual = ordenParcialidades.parcialidadActual;
                //const parcialidadTotal = ordenParcialidades.totalParcialidades;
                //  const numPago = `${parcialidadActual + 1} / ${parcialidadTotal}`;

                /*const parcialidad =
                  ordenParcialidades.productoParcialidades[parcialidadActual];*/
                /*  const pagoRequerido = Singleton.getInstance().format(
                parcialidad.total
              );*/

                //const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");

                //const fechaInicial = "";
                /*format(
                parcialidad.fechaInicio,
                "dd-MMM-yyyy"
              );*/
                //  const fechaFin = ""; // format(parcialidad.fechaFin, "dd-MMM-yyyy");
                //const fechaRango = `${fechaInicial} - ${fechaFin}`;
                //const fechaRango = ""; //`${fechaInicial}`;

                //  const start = new Date();
                /*start.setMonth(monthIndex);
                                start.setDate(1);*/
                //  const clientes = asociadosClientes[item.id] ?? [];
                //-      const clientes = item.clientes;
                /*
              const item = value.asociado;
              const nombre = buildName(item, true);
              const totalPagar = Singleton.getInstance().format(value.total);
*/
                //      const start = new Date();
                /*start.setMonth(monthIndex);
                  start.setDate(1);*/

                /*    const fechaInicial = format(start, "yyyy-MMM-dd");
              const clientes = asociadosClientes[item.id] ?? [];*/

                //-  const isClientLoading = tDetalleIsShownRef.current[index] && clientes.length === 0;

                const displayDetalle = {
                  display: tDetalleIsShownRef.current[index]
                    ? "table-row"
                    : "none",
                };

                return (
                  <>
                    <tr
                      className="conciliacion-table table-secondary"
                      key={cobranzaItem.id}
                      onClick={(event) => toggleDetails(index, cobranzaItem.id)}
                      style={{
                        fontWeight: tDetalleIsShownRef.current[index]
                          ? "bold"
                          : "normal",
                        backgroundColor: tDetalleIsShownRef.current[index]
                          ? "#C1E6EC"
                          : "white",
                      }}
                    >
                      <td style={{ textAlign: "left" }}>{nombre}</td>

                      <td style={{ textAlign: "center" }}>--</td>

                      <td style={{ textAlign: "center" }}>--</td>

                      <td style={{ textAlign: "center" }}>--</td>

                      <td style={{ textAlign: "center" }}>--</td>

                      <td style={{ textAlign: "center" }}>{clienteAbono}</td>

                      <td style={{ textAlign: "center" }}>{clientePagado}</td>

                      <td style={{ textAlign: "center" }}>{clienteDebe}</td>

                      <td style={{ textAlign: "center" }}>{clienteActual}</td>

                      <td style={{ textAlign: "center" }}>
                        {clienteAdeudoQuincenal}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {clienteNuevoSaldo}
                      </td>

                      <td style={{ textAlign: "center" }}>{clienteComision}</td>

                      <td style={{ textAlign: "center" }}>
                        {clienteAbonoAdicional}
                      </td>

                      <td
                        className="d-flex"
                        style={{ flexDirection: "column", gap: "5px" }}
                      >
                        <div className="">
                          <button
                            type="button"
                            className="btn "
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ borderColor: "transparent" }}
                          >
                            <HiDotsVertical />
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={
                                  (event) =>
                                    abonarCliente?.(event, cobranzaItem)
                                  //abonarProducto?.(event, cobranzaItem, null)
                                }
                                disabled={disableClienteAbonar}
                              >
                                <PiHandshakeFill
                                  size={25}
                                  style={{ marginRight: "10px" }}
                                />
                                Crear Convenio Total
                              </a>
                            </li>

                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={
                                  (event) => openConvenio?.(event, cobranzaItem)
                                  //abonarProducto?.(event, cobranzaItem, null)
                                }
                              >
                                <PiHandshake
                                  size={25}
                                  style={{ marginRight: "10px" }}
                                />
                                Crear Convenio Parcial
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>

                    {productoParcialidades.map((productoParcialidad, index) => {
                      //const cliente = productoParcialidadCliente.cliente;

                      const ordenVentaDetalle =
                        productoParcialidad?.ordenVentaDetalle;
                      let nombreProducto =
                        ordenVentaDetalle?.producto?.nombre ?? "";

                      const ordenId = ordenVentaDetalle.ordenVentaId ?? 0;
                      //-
                      let fechaVenta = format(
                        productoParcialidad.ordenesVenta.fechaOrden,
                        "dd-MMM-yyyy",
                      );

                      let precio = Singleton.getInstance().format(
                        ordenVentaDetalle.precio,
                      );

                      let plazo = `${productoParcialidad.parcialidadNumero}/${productoParcialidad.parcialidades.length}`;

                      let currentParcialidad =
                        productoParcialidad?.parcialidades.find(
                          (e) =>
                            e.parcialidadNumero ===
                            productoParcialidad?.parcialidadNumero,
                        );

                      let abono = currentParcialidad.total;
                      abono = Singleton.getInstance().format(abono);

                      /*  productoParcialidad.parcialidades.some(
                                        (e, index) => {
                                          if (
                                            index >=
                                            productoParcialidad.parcialidadNumero
                                          )
                                            return true;
                                          abono += e.totalPagado;
                                        },
                                      );

                                      abono =
                                        Singleton.getInstance().format(abono);*/

                      let pagado = Singleton.getInstance().format(
                        productoParcialidad.totalPagado,
                      );

                      let debe = Singleton.getInstance().format(
                        productoParcialidad.totalPendiente,
                      );
                      /*
                       */

                      let kurrent = Singleton.getInstance().format(
                        currentParcialidad?.totalPagado ?? 0,
                      );

                      let adeudoQuincenal = Singleton.getInstance().format(
                        currentParcialidad?.totalPendiente ?? 0,
                      );
                      /*Singleton.getInstance().format(
                                          productoParcialidad
                                            ?.subPagoProductoAdicional?.total ??
                                            0,
                                        );*/

                      let nuevoSaldo = 0;

                      let comision = "--";

                      let abonoAdicional = Singleton.getInstance().format(
                        productoParcialidad?.subPagoProductoAdicional?.total ??
                          0,
                      );

                      /*                                      const totalPagar =
                                        Singleton.getInstance().format("23");

                                      const pendienteTotalParcialidad =
                                        Singleton.getInstance().format("");
                                        */

                      //  const ordenParcialidades =
                      //    itemCliente.ordenParcialidades;
                      //  const parcialidadActual =
                      //  ordenParcialidades.parcialidadActual;
                      //  const parcialidadTotal =
                      //  ordenParcialidades.totalParcialidades;
                      /*  const numPago = `${
                                      parcialidadActual + 1
                                    } / ${parcialidadTotal}`;*/

                      /*  const parcialidad =
                                        ordenParcialidades
                                          .productoParcialidades[
                                          parcialidadActual
                                        ];*/
                      /*const pagoRequerido =
                                      Singleton.getInstance().format(
                                        parcialidad.total
                                      );*/

                      const fechaInicial = "";
                      /*format(
                                        parcialidad.fechaInicio,
                                        "dd-MMM-yyyy",
                                      );*/
                      const fechaFin = "";
                      /*const fechaFin = format(
                                        parcialidad.fechaFin,
                                        "dd-MMM-yyyy",
                                      );*/
                      //const fechaRango = `${fechaInicial} - ${fechaFin}`;
                      //const fechaRango = `${fechaInicial}`;
                      const fechaRango = ""; //`${fechaInicial}`;

                      /*  const totalPagar =
                                      Singleton.getInstance().format(
                                        itemCliente.total
                                      );

                                    const pendienteTotalParcialidad =
                                      Singleton.getInstance().format(
                                        itemCliente.pendienteTotalParcialidad
                                      );*/

                      //  const start = new Date();
                      /*start.setMonth(monthIndex);        start.setDate(1);*/

                      //    const fecha = format(start, "yyyy-MMM-dd");

                      return (
                        <tr
                          className="table-light"
                          ref={(el) => {
                            tDetalleRef.current[index] = el;
                            console.log(
                              `--der ${index} ${tDetalleRef.current[index]}`,
                            );
                          }}
                          style={displayDetalle}
                        >
                          <td
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                            }}
                          >
                            <a
                              href="#"
                              onClick={(e) =>
                                /*  openItem({
                                  ...productoParcialidad,
                                  itemCliente: "",
                                })*/
                                {}
                              }
                            >
                              {ordenId}
                            </a>
                          </td>
                          <td>{nombreProducto}</td>
                          <td style={{ textAlign: "center" }}>{fechaVenta}</td>
                          <td style={{ textAlign: "center" }}>{precio}</td>
                          <td style={{ textAlign: "center" }}>{plazo}</td>
                          <td style={{ textAlign: "center" }}>{abono}</td>
                          <td style={{ textAlign: "center" }}>{pagado}</td>
                          <td style={{ textAlign: "center" }}>{debe}</td>
                          <td style={{ textAlign: "center" }}>{kurrent}</td>
                          <td style={{ textAlign: "center" }}>
                            {adeudoQuincenal}
                          </td>
                          <td style={{ textAlign: "center" }}>{nuevoSaldo}</td>

                          <td style={{ textAlign: "center" }}>{comision}</td>
                          <td style={{ textAlign: "center" }}>
                            {abonoAdicional}
                          </td>
                          <td>
                            {/* 
                            <button
                              type="button"
                              className="btn btn-sm btn-warning"
                              onClick={(event) =>
                                abonarProducto?.(
                                  event,
                                  cobranzaItem,
                                  productoParcialidad,
                                )
                              }
                              disabled={true}
                            >
                              Abonar
                            </button>
                            */}
                          </td>
                        </tr>
                      );
                    })}

                    {cobranzaItem.interestItems.map((interestItem, index) => {
                      //const cliente = productoParcialidadCliente.cliente;

                      let nombreProducto = "INTERES";

                      const ordenId = "-";
                      let fechaVenta = format(
                        interestItem.fechaFin,
                        "dd-MMM-yyyy",
                      );

                      let precio = Singleton.getInstance().format(
                        interestItem.total,
                      );

                      let plazo = `1/1`;
                      let abono = Singleton.getInstance().format(
                        interestItem.total,
                      );

                      let pagado = Singleton.getInstance().format(
                        interestItem.totalPagado,
                      );

                      let debe = Singleton.getInstance().format(
                        interestItem.totalPendiente,
                      );

                      let kurrent = Singleton.getInstance().format(
                        interestItem?.totalPagado ?? 0,
                      );

                      let adeudoQuincenal = Singleton.getInstance().format(
                        interestItem?.totalPendiente ?? 0,
                      );

                      let nuevoSaldo = 0;
                      let comision = "--";

                      let abonoAdicional = Singleton.getInstance().format(0);

                      return (
                        <tr
                          className="table-light"
                          ref={(el) => {
                            tDetalleRef.current[index] = el;
                            console.log(
                              `--der ${index} ${tDetalleRef.current[index]}`,
                            );
                          }}
                          style={displayDetalle}
                        >
                          <td
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                            }}
                          >
                            <a href="#" onClick={(e) => {}}>
                              {ordenId}
                            </a>
                          </td>
                          <td>{nombreProducto}</td>
                          <td style={{ textAlign: "center" }}>{fechaVenta}</td>
                          <td style={{ textAlign: "center" }}>{precio}</td>
                          <td style={{ textAlign: "center" }}>{plazo}</td>
                          <td style={{ textAlign: "center" }}>{abono}</td>
                          <td style={{ textAlign: "center" }}>{pagado}</td>
                          <td style={{ textAlign: "center" }}>{debe}</td>
                          <td style={{ textAlign: "center" }}>{kurrent}</td>
                          <td style={{ textAlign: "center" }}>
                            {adeudoQuincenal}
                          </td>
                          <td style={{ textAlign: "center" }}>{nuevoSaldo}</td>

                          <td style={{ textAlign: "center" }}>{comision}</td>
                          <td style={{ textAlign: "center" }}>
                            {abonoAdicional}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-warning"
                              onClick={(event) =>
                                abonarProducto?.(
                                  event,
                                  cobranzaItem,
                                  null,
                                  interestItem,
                                )
                              }
                              disabled={true}
                            >
                              Abonar
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
      {/** 
      <header className="App-header">
        <Line options={options} data={data} />
      </header>*/}

      {/* 
      <p>
        <a
          className="btn btn-primary"
          data-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Link with href
        </a>
        <button
          className="btn btn-primary"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          Button with data-target
        </button>
      </p>
      */}
      <div className="collapse" id="collapseExample">
        <div className="card card-body">
          {/* */}
          <div className="container33">
            <div className="entry33">
              <div className="name">name</div>
              <div className="type">type</div>
              <div className="value">value</div>
              <div className="extra">extra</div>
            </div>
            <details>
              <summary className="entry33">
                <div className="name">root</div>
                <div className="type">struct(620)</div>
                <div className="value">...</div>
              </summary>
              <div className="sub-entries" style={{ "--depth": 1 }}>
                <details>
                  <summary className="entry33">
                    <div className="name">header</div>
                    <div className="type">struct(12)</div>
                    <div className="value">...</div>
                  </summary>
                  <div className="sub-entries" style={{ "--depth": 2 }}>
                    <div className="entry33">
                      <div className="name">signature</div>
                      <div className="type">string(4)</div>
                      <div className="value">"XMPL"</div>
                    </div>
                    <div className="entry33">
                      <div className="name">version</div>
                      <div className="type">number(2)</div>
                      <div className="value">0</div>
                    </div>
                    <div className="entry33">
                      <div className="name">padding</div>
                      <div className="type">none(2)</div>
                      <div className="value">00</div>
                    </div>
                  </div>
                </details>
              </div>
            </details>
          </div>

          {/* */}
        </div>
      </div>
    </>
  );
}
